import AIBanner from '@components/AIBanner';
import React from 'react';
export default function AiProductCallout() {
    return React.createElement(AIBanner, null);
}
